import { CircularProgress } from '@mui/material';
import s from './LoadingPage.module.scss';

const LoadingPage = () => {
  return (
    <div className={s.loading}>
      <CircularProgress color="primary" size={60} />
      <p className={s.loading__text}>Подготавливаем рабочее место...</p>
    </div>
  );
};

export default LoadingPage;
